import { useState } from 'react'
import { Link as RRLink } from 'react-router-dom'
import OtpInput from 'react-otp-input'

import { loginRegenerateOTP } from '@/actions/authActions'
import { useAppDispatch } from '@/utils/typeHelpers'

import { Colors, Fonts } from '@/src/styles/theme'
import { TypographyStyles } from '@/styles'
import { Button, Text, Link, Alert, Card } from '@/ui'

interface OTPLoginProps {
  email: string
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  loginError: string | undefined
  otp: string | undefined
  setOtp: (otp: string) => void
  password: string
  phoneDigits: string
}

export const OTPLogin = ({
  email,
  onSubmit,
  loginError,
  otp,
  setOtp,
  password,
  phoneDigits,
}: OTPLoginProps) => {
  const [resentCode, setResentCode] = useState(false)
  const dispatch = useAppDispatch()

  const resendCode = async () => {
    const result = await loginRegenerateOTP({
      email: email.toLowerCase(),
      password,
    })(dispatch)

    if (result) {
      setResentCode(true)
    }
  }

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault()
    setResentCode(false)
    onSubmit(evt)
  }

  return (
    <>
      <Card className="w-full md:w-3/4 lg:w-1/2 mx-auto">
        {loginError && <Alert variant="error" title={loginError} />}

        <div className="flex flex-col space-y-4">
          <Text variant={TypographyStyles.H2} textAlign="center">
            Enter verification code
          </Text>

          <Text textAlign="center">
            We sent a verification code to your number on file ending in:{' '}
            {phoneDigits}
          </Text>

          <form onSubmit={handleSubmit}>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              shouldAutoFocus
              renderInput={(props) => <input {...props} />}
              inputStyle={{
                width: 45,
                border: `1px solid ${Colors.gray}`,
                borderRadius: 8,
                color: Colors.black,
                padding: '10px 16px',
                margin: '10px 3px',
                ...Fonts.bodyMd,
              }}
              containerStyle={{ justifyContent: 'center' }}
            />

            <Button type="submit" disabled={!otp}>
              Verify
            </Button>
          </form>
        </div>
      </Card>

      <div className="flex justify-center">
        <Button variant="link" onClick={resendCode} disabled={resentCode}>
          {resentCode
            ? 'Verificatioin code resent!'
            : 'Resend your verification code'}
        </Button>
      </div>

      <div className="min-h-fit flex justify-center">
        <RRLink to="/recover">Forgot password</RRLink>
      </div>

      <div className="min-h-fit flex flex-col items-center">
        <Text textAlign="center">Not receiving your verification code?</Text>

        <Text textAlign="center">Email us at </Text>

        <Link href="mailto: support@joinheard.com">support@joinheard.com</Link>
      </div>
    </>
  )
}
